import { Injectable } from '@angular/core';
import { share, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  private mainContainerScroll = new Subject<Event>();

  mainContentScroll$ = this.mainContainerScroll.asObservable().pipe(share());

  download(fileName: string, blob: Blob): void {
    const file = new File([blob], fileName, {
      type: blob.type,
    });
    const url = window.URL.createObjectURL(file);
    const a = window.document.createElement('a');
    window.document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  getCurrentFormattedDate(): string {
    const date = new Date();

    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();
    const hours = `${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);

    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  }

  mainContentScroll(event: Event): void {
    this.mainContainerScroll.next(event);
  }
}
